import { LoginState, LoginActionTypes, loginActionNames } from './types';

const initialState: LoginState = {
  isLoginSuccess: false,
  isLoginPending: false,
  loginError: null,
  client: null,
  authInfo: null,
  envVariables: {
    redirectURI: '',
    globalSearchV2BaseUrl: '',
    authRedirect: '',
    assetManagementBaseURL: '',
    deviceApiV2BaseUrl: '',
    devicesV1BaseUrl: '',
    clientId: '',
    userPreferencesV2BaseUrl: '',
    entitlementsV1BaseUrl: '',
    entitlementRoleManagementV1BaseUrl: '',
    transactionsV1BaseUrl: '',
    parsedMessageV1BaseUrl: '',
    commandsV1BaseUrl: '',
    carrierManagementV1BaseUrl: '',
    rebootConfigV1BaseUrl: '',
    rebootConfigV2BaseUrl: '',
    fileTypeConfigV1BaseUrl: '',
    fileTypeConfigV2BaseUrl:'',
    configurationFilesV1BaseUrl: '',
    pingCommandsV2BaseUrl: '',
    configurationFilesLibraryV1BaseUrl: '',
    shortCommandsV1BaseUrl: '',
    shortCommandsV2BaseUrl: '',
    shortMessageRequestConfigurationV1BaseUrl: '',
    saberRekeyV1BaseUrl: '',
    transferOverrideConfigurationsV1BaseUrl: '',
    meterValueConfigurationV2BaseUrl: '',
    geoFenceConfigBaseUrl: '',
    assetsV2BaseUrl: '',
    assetDeviceConfigV2BaseUrl: '',
    lastMessageTransmission: '',
    storageV1BaseUrl: '',
    subscriptionCatalogV1BaseUrl: '',
    remoteFlashV1BaseUrl: '',
    flashLogsV1: '',
    subscriptionConfig: '',
    homingV2BaseUrl: '',
    legacyMMSGatewaySupportPortalLink: '',
    deviceWakeUpsV2: '',
    preferredNetworkAndOTASPV1: '',
    wifiConfigurationsV1: '',
    restrictedAssetsV1: '',
    tokenURI: '',
    disableFaultCode: '',
    antiForgeryTtl: 30,
    proofCodeTtl: 25,
    leniency: 2,
    campaignURL: '',
    UserAccessManagementV1BaseUrl: '',
    configCapability: '',
    locatorCommandURL: '',
    vimsSFTPUsers: '',
    vimsSFTPReportV1: '',
    subscriptionConfigV2BaseUrl: '',
    deviceMigrationV1: '',
    modemFlashFirmwareURL: '',
    switchConfigurationsV1: '',
    configManangementV1BaseUrl: '',
    panelConfigurationV1BaseUrl: '',
  },
};

export const loginReducer = (
  state: LoginState = initialState,
  action: LoginActionTypes,
): LoginState => {
  switch (action.type) {
    case loginActionNames.SET_LOGIN_PENDING: {
      return {
        ...state,
        isLoginPending: action.payload,
      };
    }
    case loginActionNames.SET_LOGIN_SUCCESS: {
      return {
        ...state,
        isLoginSuccess: action.payload,
      };
    }
    case loginActionNames.SET_LOGIN_ERROR: {
      return {
        ...state,
        loginError: action.payload,
      };
    }
    case loginActionNames.SET_LOGOUT: {
      return {
        ...state,
        isLoginSuccess: false,
        isLoginPending: false,
      };
    }
    case loginActionNames.SET_CLIENT: {
      return {
        ...state,
        client: action.payload,
      };
    }
    case loginActionNames.SET_ENV_VARIABLES: {
      return {
        ...state,
        envVariables: action.payload,
      };
    }
    default:
      return state;
  }
};
